(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ShopperProfilesCtrl', ShopperProfilesCtrl);


  // @ngInject
  function ShopperProfilesCtrl(filters, storeKeys, genderData, ShopperProfiles, ConsumerChartDisplay, SectionConfig,
                               StandardReports, ReportFormat, Filters) {
    var vm = this;
    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};
    vm.transactionColorSwatch = [
      {keys: [ConsumerChartDisplay.Colors.tfLine.stroke], value: '% of Consumers'}
    ];
    vm.genderData = genderData;
    vm.selectedGender = genderData && genderData[0] && genderData[0].range;

    vm.displayGender = ShopperProfiles.genderDisplay;

    var shopperProfileSections = [ SectionConfig.ageProfiles, SectionConfig.heightProfiles, SectionConfig.weightProfiles,
      SectionConfig.inseamProfiles, SectionConfig.footLengthProfiles, SectionConfig.bustSizeProfiles ];

    var bodyShapeSections = [ SectionConfig.torsoLengthProfiles, SectionConfig.stomachShapeProfiles,
      SectionConfig.hipShapeProfiles, SectionConfig.thighShapeProfiles, SectionConfig.archShapeProfiles,
      SectionConfig.calfShapeProfiles, SectionConfig.breastShapeProfiles, SectionConfig.buildProfiles,
      SectionConfig.seatShapeProfiles ];

    vm.loadCharts = function () {
      //reload all
      vm.shopperProfileCharts = getShopperProfileOptions(shopperProfileSections, vm.selectedGender);
      vm.bodyShapeCharts = [];

      // StandardReports.getConsumerData('body-shape', ReportFormat.Daily, queryFilters).then(function (data) {
      //   var bodyShapes = ShopperProfiles.getMeasurements(data, vm.selectedGender, 'bodyShape');
      //   var filteredSections = _.filter(bodyShapeSections, function (section) {
      //     return _.includes(bodyShapes, section.name);
      //   });
      //
      //   vm.bodyShapeCharts = getBodyShapeOptions(filteredSections, vm.selectedGender);
      // });
    };

    vm.showBodyShapes = function () {
      return _.some(vm.bodyShapeCharts, function (chart) {
        return chart.chartOptions.showChart();
      })
    };

    function getShopperProfileOptions(sections, gender) {
      return _(sections)
          .filter(function (section) {
            return !_.eq(section, SectionConfig.bustSizeProfiles) ||
                (_.eq(section, SectionConfig.bustSizeProfiles) && vm.selectedGender !== 'Male')
          })
          .map(function(section) {
            return {
              getData: function() {
                return StandardReports.getConsumerData(section.api, ReportFormat.Daily, queryFilters);
              },
              chartOptions: ShopperProfiles.getChartOptions(section),
              dataOptions: function (rawData) {
                var selectedUnit = this.chartOptions && this.chartOptions.selectedUnit;
                return ShopperProfiles.getDataOptions(rawData, gender, selectedUnit, ShopperProfiles.shopperProfilesData);
              },
              setParentValues: function() {
                updateFilter();
              },
              onUnitChange: function (selectedUnit) {
                this.chartOptions = ShopperProfiles.getChartOptions(section, selectedUnit);
                updateFilter();
              }
            };
          })
          .value();
    }

    function getBodyShapeOptions(sections, gender) {
      return _.map(sections, function(section) {
        return {
          getData: function() {
            return StandardReports.getConsumerData(section.api, ReportFormat.Daily, queryFilters);
          },
          chartOptions: ShopperProfiles.getChartOptions(section),
          dataOptions: function (rawData) {
            return ShopperProfiles.getDataOptions(rawData, gender, section.name, ShopperProfiles.bodyShapeData)
          }
        };
      });
    }

    function updateFilter() {
      var filters = Filters.getFilter();

      var unitParams = _(vm.shopperProfileCharts)
          .filter(function (chart) {
            return !_.isNil(chart.chartOptions.selectedUnit);
          })
          .reduce(function (acc, chart) {
            acc[chart.chartOptions.name + "Unit"] = chart.chartOptions.selectedUnit;
            return acc;
          }, {});

      filters.dashboardSpecificParams = _.merge({}, unitParams, { gender: vm.selectedGender });

      Filters.setFilter(filters);
    }

    vm.loadCharts();
  }


})();
